import { dataDataSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDataSolid = /*#__PURE__*/createIcon(dataDataSolid)
export default IconDataSolid
